export default "__VITE_ASSET__DvJnweiH__"